import React, { useState, Fragment, useEffect } from "react";
import DataTable from "react-data-table-component";
import { Link, useAsyncError, useNavigate } from "react-router-dom";
import { FaEdit } from "react-icons/fa";
import { Form, Dropdown } from "react-bootstrap";
import { networkHideShowAxios, newWorkListGet } from "../../Actions/axios";
import { toast } from "react-toastify";

const NetworkList = () => {
  const navigate = useNavigate();
  const [networkList, setNetworkList] = useState([]);

  const getNetworkList = async () => {
    let resp = await newWorkListGet();
    console.log("🚀 ~ getNetworkList ~ resp:", resp);
    if (resp?.status) {
      setNetworkList(resp?.data);
    }
  };

  const networkHideShow = async (id)=>{
    let resp = await networkHideShowAxios({_id : id })
    console.log("🚀 ~ networkHideShow ~ resp:", resp);
    if(resp?.status){
     toast.success(resp?.message);
     getNetworkList();
    }
  }

  const columns = [
    {
      name: "S.no",
      align: "left",
      sortable: false,
      selector: (row, i) => <p>{i + 1}</p>,
    },
    {
      name: "Name",
      align: "left",
      sortable: false,
      selector: (row, i) => <p>{row?.name}</p>,
    },
    {
      name: "isVisible",
      align: "left",
      sortable: false,
      selector: (row, i) => {
        return (
          <>
            <button type="button" className="btn sitebtn" onClick={()=>networkHideShow(row?._id)}>
              {row?.isvisible ? "HIDE" : "SHOW"}
            </button>
          </>
        );
      },
    },
    {
      name: "Edit",
      align: "left",
      sortable: false,
      selector: (row, i) => {
        return (
          <Fragment>
            <button
              className={`btn sitebtn btn-sm ${row._id}`}
              onClick={() =>
                navigate("/networkedit", {
                  state: {
                    ...row,
                  },
                })
              }
            >
              <FaEdit />
            </button>
          </Fragment>
        );
      },
    },
  ];


  useEffect(
    () => {
      getNetworkList();
    },
    [
      // searchtext, type, page, limit
    ]
  );
  return (
    <div className="cmslist">
      <h1 className="pagehead">Network List</h1>
      <div className="cardbox">
        <div className="d-flex align-items-center justify-content-end gap-3 mb-4">
          <Link to="/networkadd" className="btn sitebtn">
            Add
          </Link>
        </div>
        <div className="tablebox">
          <DataTable
            className="react-datatables"
            columns={columns}
            data={networkList}
            pagination
            paginationRowsPerPageOptions={[5, 10, 15, 20]}
            // onChangeRowsPerPage={(e) => setLimit(e)}
            // onChangePage={(e) => setPage(e - 1)}
          />
        </div>
      </div>
    </div>
  );
};

export default NetworkList;
